import Image from 'next/image'
import React, { PropsWithChildren } from 'react'
import { HomeVideoBanner } from './homeBannerVideo'
import { ImageContainer, VideoBannerWrapper, MobileBannerVector } from './styledHomeBanner'
import { theme } from '../../../../theme'
import { useMediaQuery } from '@material-ui/core'

type HomeBannerMaskProps = {
  src: string
  mobileSrc: string
  desktopVectorRight?: string | null | undefined
  mobileVector?: string | null | undefined
  videoId?: string
}

export const HomeBannerMask: React.FC<PropsWithChildren<HomeBannerMaskProps>> = ({
  src,
  mobileSrc,
  desktopVectorRight,
  mobileVector,
  children,
  videoId,
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const vectorSrc = isMobile ? mobileVector ?? undefined : desktopVectorRight ?? undefined

  return (
    <>
      <div>
        <ImageContainer>
          {!isMobile ? (
            <Image
              src={src}
              layout="fill"
              quality={100}
              alt={''}
            />
          ) : (
            <Image
              src={mobileSrc}
              objectFit="cover"
              layout="fill"
              alt={''}
            />
          )}

          {isMobile && vectorSrc && (
            <MobileBannerVector>
              <Image
                src={vectorSrc}
                alt={''}
                objectFit="contain"
                layout="fill"
              />
            </MobileBannerVector>
          )}
        </ImageContainer>
        <VideoBannerWrapper>
          <HomeVideoBanner videoId={videoId || ''} videoType="vimeo" />
        </VideoBannerWrapper>
      </div>
      {children}
    </>
  )
}


